import { useEffect, useState } from 'react'
import { Main } from '@/components/Main'
import { WorkInfo } from '@/components/WorkInfo'
import TopBar from '@/components/TopBar'
import { useLoginValue } from '@/hooks/useLoginValue'
import Loader from '@/components/Loader'

const MainPage = () => {
  const { userInfo } = useLoginValue()
  const [isLoaded, setIsLoaded] = useState(false)
  const [status, setStatus] = useState({
    type: 'ok',
    message: '',
  })

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true)
    }, 300)
  })

  return (
    <>
      {status?.type === 'error' && (
        <div className="fixed left-0 top-0 z-20 w-full h-full flex justify-center items-center bg-black">
          <div>
            <div>
              {status?.message.split('<br />').map((item, index) => {
                return (
                  <div key={index}>
                    <span className="block">{item}</span>
                  </div>
                )
              }) || '잠시후 다시 시도해주세요.'}
            </div>
            <button
              type="button"
              className="mt-2 p-1 text-sm border-solid border-[1px] border-white rounded bg-white text-black"
              onClick={() => setStatus({ type: 'ok' })}
            >
              돌아가기
            </button>
          </div>
        </div>
      )}
      <>
        <TopBar />
        {isLoaded ? userInfo ? <WorkInfo handleStatus={setStatus} /> : <Main /> : <Loader />}
      </>
    </>
  )
}

export default MainPage
